import {getStatisticsUserSumElect,getStatisticsUserSumMoney,getStatisticsEntSumElect,getStatisticsEntSumAmount} from "@/common/api";

/**
 * key 和下面的方法对应
 */
const cententKey = {
  memberDl: 'getMemberDlData',
  memberMoney: 'getMemberMoneyData',
  entPersonal: 'getEntPersonalData',
  entAdminPay: 'getEntAdminPayData',
  entAdminPersonalPay: 'getEntAdminPersonalPayData',
  entPay: 'getEntPayData',
}
/**
 * tab
 */
const cententTabsList = {
  'member': [
    {name: '按电量', value: cententKey.memberDl },
    {name: '按金额', value: cententKey.memberMoney },
  ],
  'entAdmin': [
    {name: '个人', value: cententKey.entPersonal },
    {name: '统付', value: cententKey.entAdminPay },
    {name: '个付', value: cententKey.entAdminPersonalPay },
  ],
  entPay: [{name: '个人', value: cententKey.entPersonal },],
  entPersonalPay: [{name: '个付', value: cententKey.entPersonal },]
}
/**
 * 普通会员按电量
 * @returns 
 */
const getMemberDlData = ()=>{
  return new Promise(async(resolve) => {
    let ret = await getStatisticsUserSumElect({});
    let data = {}
    if(ret.status == 0){
      data = ret.data[0] || {};
    }
    let blockDataList = [ blockDataListDlTemplate(data)]
    resolve(blockDataList)
  })
}
/**
 * 普通会员按金额
 * @returns 
 */
const getMemberMoneyData = ()=>{
  return new Promise(async(resolve) => {
    
    let ret = await getStatisticsUserSumMoney({});
    let data = {}
    if(ret.status == 0){
      data = ret.data[0] || {};
    }
    let blockDataList = [ blockDataListMoneyTemplate(data)]
    resolve(blockDataList)
  })
  
}

/**
 * 企业管理员 - 个人，  企业个付 /企业统付都是   个人  1
 * @returns 
 */
const getEntPersonalData = ()=>{
  return new Promise(async(resolve) => {
    // 电量 
    let ret = await getStatisticsEntSumElect({dataType: 1});
    let dataDl = {}
    if(ret.status == 0){
      dataDl = ret.data[0] || {};
    }
    // 金额
    let rets = await getStatisticsEntSumAmount({dataType: 1});
    let dataMoney = {}
    if(rets.status == 0){
      dataMoney = rets.data[0] || {};
    }
    let blockDataList = blockDataListTemplate(dataDl,dataMoney) 
    resolve(blockDataList)
  })
  
  
}

/**
 * 企业管理员 统付
 * @returns 
 */
const getEntAdminPayData = ()=>{
  return new Promise(async(resolve) => {
    // 电量 
    let ret = await getStatisticsEntSumElect({dataType: 3});
    let dataDl = {}
    if(ret.status == 0){
      dataDl = ret.data[0] || {};
    }
    // 金额
    let rets = await getStatisticsEntSumAmount({dataType: 3});
    let dataMoney = {}
    if(rets.status == 0){
      dataMoney = rets.data[0] || {};
    }
    let blockDataList = [
      blockDataListDlTemplate(dataDl),
      blockDataListMoneyTemplate(dataMoney),
      
    ]
    resolve(blockDataList)
  })
}

/**
 * 企业管理员 个付
 * @returns 
 */
const getEntAdminPersonalPayData = ()=>{
  return new Promise(async(resolve) => {
    // 电量 
    let ret = await getStatisticsEntSumElect({dataType: 2});
    let dataDl = {}
    if(ret.status == 0){
      dataDl = ret.data[0] || {};
    }
    // 金额
    let rets = await getStatisticsEntSumAmount({dataType: 2});
    let dataMoney = {}
    if(rets.status == 0){
      dataMoney = rets.data[0] || {};
    }

    let blockDataList = blockDataListTemplate(dataDl,dataMoney) 
    
    resolve(blockDataList)
  })
  
}

/**
 * 企业支付/企业个人支付
 * @returns 
 */
const getEntPayData = ()=>{
  // 和管理员 个人 是一样的
  return getEntPersonalData;
  
}
/**
 * 电量和金额在一起的模板
 * @param {*} dataDl 
 * @param {*} dataMoney 
 * @returns 
 */
const blockDataListTemplate = (dataDl,dataMoney)=>{
  let blockDataList = [
    {
      title: '(单位:kWh)',
      row: 2,
      list: [
        {name: '上月充电量', value: dataDl.lastMonthElec || 0},
        {name: '本月充电量', value: dataDl.currMonthElec || 0},
        {name: '今年充电量', value: dataDl.currYearElec || 0},
        {name: '累计充电电量', value: dataDl.sumElec || 0},
      ]
    },
    {
      title: '(单位:元)',
      row: 4,
      list: [
        {name: '消费总金额', value: dataMoney.sumAmount || 0},
        {name: '上月消费', value: dataMoney.lastMonthAmount || 0},
        {name: '本月消费', value: dataMoney.currMonthAmount || 0},
        {name: '今年消费', value: dataMoney.currYearAmount || 0},
      ]
    }
  ]
  return blockDataList;
}
/**
 * 只有电量 的模板
 * @param {*} data 
 */
const blockDataListDlTemplate = (data)=>{
  return {
    title: '(单位:kWh)',
    row: 2,
    list: [
      {name: '上月充电量', value: data.lastMonthElec || 0},
      {name: '本月充电量', value: data.currMonthElec || 0},
      {name: '今年充电量', value: data.currYearElec || 0},
      {name: '累计充电电量', value: data.sumElec || 0},
    ]
  }
}
/**
 * 只有金额的模板
 * @param {*} data 
 * @returns 
 */
const blockDataListMoneyTemplate = (data)=>{
  return {
    title: '(单位:元)',
    row: 3,
    list: [
      {name: '上月消费', value: data.lastMonthAmount || 0},
      {name: '本月消费', value: data.currMonthAmount || 0},
      {name: '今年消费', value: data.currYearAmount || 0},
      {name: '消费总金额', value: data.sumAmount || 0},
      {name: '充值总金额', value: data.sumRechargeAmount || 0},
      {name: '退款总金额', value: data.sumRefundAmount || 0},
    ]
  }
}

export default{
  cententKey,
  cententTabsList,
  getMemberDlData,
  getMemberMoneyData,
  getEntPersonalData,
  getEntAdminPayData,
  getEntAdminPersonalPayData,
  getEntPayData,
}